import { render, staticRenderFns } from "./RegistrationView.vue?vue&type=template&id=432e2cfe&"
import script from "./RegistrationView.vue?vue&type=script&lang=js&"
export * from "./RegistrationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports